import React, { memo } from "react";
import { Grid, Typography } from "@mui/material";
import { useStyles } from "./styles";

const Footer = () => {
  const classes = useStyles();

  return (
    <Grid
      className={classes.footer_container}
    >
      <Grid className={classes.footer}>
        <Typography className={classes.footer_text}>
          ©{new Date().getFullYear()} Convio. All Rights Reserved.
          {/* <span
          onClick={() => navigate("/privacy")}
          style={{ cursor: "pointer" }}
        >
          Privacy Policy
        </span> */}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default memo(Footer);
